import { defineComponent } from "vue";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { Flow } from "@/interfaces/sdk-flow";
import { sort } from "@/utils/array-functions";
import { handleErrors } from "@/utils/handle-errors";
import { generateUrl, mountUrlParams } from "../form-utils";
import { EventBus } from "@/utils/event-bus";
import { ETypeNotification } from "@/interfaces/i-notification";

export default defineComponent({
  name: "sdk-flow-task-form-product",
  data() {
    return {
      products: [],
      searchFilter: "",
      formsList: [] as any[],
      forms: {
        EDIT: [],
      } as any,
    };
  },
  computed: {
    filteredFormsList(): any[] {
      if (this.formsList.length) {
        let filterResult = this.formsList;
        filterResult = this.formsList.filter((f: any) => f.description.toLowerCase().indexOf(this.searchFilter.toLowerCase().trim()) !== -1);
        if (filterResult.length) {
          return sort(filterResult, false, "description");
        }
        let filteredArray = this.formsList;
        filteredArray = this.formsList.filter((f: any) => f.taskName.toLowerCase().indexOf(this.searchFilter.toLowerCase().trim()) !== -1);
        return sort(filteredArray, false, "description");
      }
      return [];
    },
  },
  methods: {
    async configForm(screen: Flow.Task.Form.Screen) {
      const parameters = await mountUrlParams(screen.parameters);
      const url = generateUrl(screen.url, parameters);
      const formKey = `${screen.origin}:${url}(${screen.description})`;
      this.$emit("applyTempFormKey", formKey);
    },
    async handleChange(product: string) {
      this.searchFilter = "";
      this.formsList = [];
      if (product) {
        fetch(`core/api/external/screen/origin/${product}`)
          .then(handleErrors)
          .then(async (data: any) => {
            await this.$set(this.forms, product, data);
            this.formsList = this.forms[product];
          })
          .catch((err) => {
            EventBus.$emit("emmit-notification", {
              type: ETypeNotification.DANGER,
              title: "Erro",
              message: err[0],
            });
          });
      } else {
        this.formsList = [];
      }
    },
    async applyForm(product: Flow.Task.Form.Product, form: any) {
      document.body.dispatchEvent(
        new CustomEvent("forms:selected", {
          bubbles: true,
          detail: {
            id: `${product.key}:${form.url || form.id}(${form.description || form.descricao || form.name})`,
          },
        })
      );
      this.$emit("close");
    },
  },
  mounted() {
    fetch("core/api/system/integration")
      .then((response) => response.json())
      .then((res) => {
        this.products = res;
      });
  },
});
